import FullScreenViewState from 'redux/fullScreenView/interfaces/fullScreenViewState';

const INIT_FULL_SCREEN_VIEW_STATE: FullScreenViewState = {
  content: null,
  onCloseAdditionalAction: undefined,
};

export default INIT_FULL_SCREEN_VIEW_STATE;
